/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Order } from './Order';
import {
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
    OrderToJSONTyped,
} from './Order';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface OrdersListResponse
 */
export interface OrdersListResponse {
    /**
     * 
     * @type {Array<Order>}
     * @memberof OrdersListResponse
     */
    data: Array<Order>;
    /**
     * 
     * @type {Pagination}
     * @memberof OrdersListResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the OrdersListResponse interface.
 */
export function instanceOfOrdersListResponse(value: object): value is OrdersListResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function OrdersListResponseFromJSON(json: any): OrdersListResponse {
    return OrdersListResponseFromJSONTyped(json, false);
}

export function OrdersListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdersListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(OrderFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

export function OrdersListResponseToJSON(json: any): OrdersListResponse {
    return OrdersListResponseToJSONTyped(json, false);
}

export function OrdersListResponseToJSONTyped(value?: OrdersListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(OrderToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

